module.exports = __webpack_public_path__ + "static/media/banner-logo.5a203bdc.png";